import { render, staticRenderFns } from "./TabPlaceholder.vue?vue&type=template&id=0d6448d8&"
import script from "./TabPlaceholder.vue?vue&type=script&lang=js&"
export * from "./TabPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./TabPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports